/** Menu tabs that are not a category: every dish, or the guest's hearted dishes. */
export const ALL_TAB = "__all__";
export const FAVORITES_TAB = "__favorites__";
